import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  addFormTemplatesToStore,
  updateFormTemplateFromStore,
  removeFormTemplateFromStore,
} from 'src/store/intake_forms/actions';

const FormTemplatesHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return addFormTemplatesToStore(items);
    case EVENTS.MODIFY:
      return updateFormTemplateFromStore(items);
    case EVENTS.REMOVE:
      return removeFormTemplateFromStore(items);
    default:
      break;
  }
  return null;
};

export default FormTemplatesHandler;
